<template>
  <v-btn block outlined color="primary" :to="{ name: 'logout' }">{{
    $t('common.logout')
  }}</v-btn>
</template>

<script>
export default {
  name: 'Logout',
  components: {},
  props: {},
  computed: {},
  mounted() {},
  methods: {
    doLogout() {
      this.$store.dispatch('user/logout')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
